import type { ViewStyle } from 'react-native';

const align = {
  items_center: {
    alignItems: 'center',
  },
  items_start: {
    alignItems: 'flex-start',
  },
  items_end: {
    alignItems: 'flex-end',
  },
  items_baseline: {
    alignItems: 'baseline',
  },
  items_stretch: {
    alignItems: 'stretch',
  },
  content_center: {
    alignContent: 'center',
  },
  content_start: {
    alignContent: 'flex-start',
  },
  content_end: {
    alignContent: 'flex-end',
  },
  content_stretch: {
    alignContent: 'stretch',
  },
  content_between: {
    alignContent: 'space-between',
  },
  content_around: {
    alignContent: 'space-around',
  },
  self_auto: {
    alignSelf: 'auto',
  },
  self_center: {
    alignSelf: 'center',
  },
  self_start: {
    alignSelf: 'flex-start',
  },
  self_end: {
    alignSelf: 'flex-end',
  },
  self_stretch: {
    alignSelf: 'stretch',
  },
  self_baseline: {
    alignSelf: 'baseline',
  },
} satisfies Record<string, ViewStyle>;

export default align;
